import Request from "services";
import { Endpoints } from "services/endpoints";
import { handleRequestError } from "utils";
import {
  OverviewRequestParams,
  OverviewResponseData,
  TransactionRequestParams,
  TransactionResponseData,
} from "./types";
import { Transaction } from "interface/transaction";

export const getTransactions = async (params?: TransactionRequestParams) => {
  try {
    const response = await Request.getWithUserToken<TransactionResponseData>(
      Endpoints.transactions,
      {
        params: params,
      }
    );
    return response;
  } catch (error) {
    handleRequestError(error);
  }
};

export const getTransaction = async (id: string) => {
  try {
    const response = await Request.getWithUserToken<Transaction>(
      Endpoints.transaction(id),
    );
    return response;
  } catch (error) {
    handleRequestError(error);
  }
};

export const getOverview = async (params?: OverviewRequestParams) => {
  try {
    const response = await Request.getWithUserToken<OverviewResponseData>(
      Endpoints.overview,
      {
        params: params,
      }
    );
    return response;
  } catch (error) {
    handleRequestError(error);
  }
};
